import {
  trackCreditDialog,
  trackCreditDialogAction,
  trackLearnMore,
} from "@/events/creditMixpanel";
import type { CreditDialogParams } from "@repo/shared/analytics";
import { useCreditDialogTracking as useSharedCreditDialogTracking } from "@repo/shared/hooks";

/*
  Web's binding of the shared dialog-tracking hook.

  The latch — one exit per dialog instance, whichever of close / "Maybe later" /
  "Learn more" happens first — lives in @repo/shared/hooks so both apps report
  the same shape. Only the transport differs: web tracks through its own
  events layer, and the shared analytics port is a deliberate no-op here, so the
  trackers have to be handed in rather than taken from the port.
*/
const WEB_TRACKERS = {
  onShown: trackCreditDialog,
  onExit: trackCreditDialogAction,
  onLearnMore: trackLearnMore,
};

export const useCreditDialogTracking = (params: CreditDialogParams) =>
  useSharedCreditDialogTracking(params, WEB_TRACKERS);
